import React, { useEffect, useState, useRef } from 'react';
import axios from '../../../interceptors/interceptors';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import { ReactComponent as SearchOutlinedIcon } from '../../../assets/icon_search.svg';
import { ReactComponent as CloseIcon } from '../../../assets/tag-close-icon.svg';
import { ReactComponent as SearchInfoIcon } from '../../../assets/search-info-icon.svg';
import { ReactComponent as AlertMessageIcon } from '../../../assets/alert-message-icon.svg';
import { logEventHub, getMarkDown, useDetectMobile, getSecetFromAKV } from '../utils';
import SymptomCommonReason from './SymptomCommonReason';
import '../../../stylesheets/triagebot/SymptomSearchText.scss';

let searchPromise;
const symptomTextSearchUrl = '/api/symptom-search/text';
const env = process.env.REACT_APP_ASYNC_ENVIRONMENT;

const SymptomSearchMessage = ({ message, tags, setTags, showToast, setBodyPartHover, disabled, HoverColor,evisits,setevisits,setToastMessage,toastrClicked, symptomError,hasOnlyInvalidSymptomsSelected }) => {
    const [loadState, setLoadState] = useState('IDLE');
    const [selection, setSelection] = useState(-1);
    const [suggestions, setSuggestions] = useState([]);
    const [search, setSearch] = useState('');
    const [debouncedQuery, setdebouncedQuery] = useState(search);
    const showAlert = hasOnlyInvalidSymptomsSelected.isInvalid || symptomError?.message;


    const keyWasPressed = useRef('');

    const { isMobile } = useDetectMobile();

    const asyncHBID = message?.AsyncHBID || 'Correlation-Id';

    const age = (message?.data[0]?.userAge)
        ? message?.data[0]?.userAge
        : 50;

    const gender = (message?.data[0]?.userSex)
        ? message?.data[0]?.userSex
        : 'male';

    const headerText = (message?.data[0]?.headerText)
        ? message?.data[0]?.headerText
        : '';

    const instructions = (message?.text)
        ? message?.text
        : '';

    const noResults = (message?.data[0]?.noResults)
        ? message?.data[0]?.noResults
        : '';

    const newSearch = (message?.data[0]?.newSearch)
        ? message?.data[0]?.newSearch
        : '';

    const placeholder = (message?.data[0]?.placeHolder)
        ? message?.data[0]?.placeHolder
        : '';

    const addMore = (message?.data[0]?.addMore)
        ? message?.data[0]?.addMore
        : '';

    const language= (message?.language)
    ? message?.language
    : '';
    const searchInformation = (message?.data[0]?.searchInformation)    
         ? message?.data[0]?.searchInformation
         : '';

    const closeButton = (message?.buttons?.[3]?.displayText)
        ? message.buttons[3].displayText
        : ((message?.buttons?.[0]?.displayText) ? message.buttons[0].displayText : 'Close');

    // const onlySix = (message?.data[0]?.onlySix)
    //     ? message?.data[0]?.onlySix
    //     : '';

    const inputDisabled = disabled;
    const listboxId = 'symptom-search-suggestions';
    const hasSuggestions = Array.isArray(suggestions) && suggestions.length > 0;
    const isPopupOpen = Boolean(search);
    const activeOptionId = (hasSuggestions && selection >= 0 && selection < suggestions.length)
        ? `symptom-suggestion-${selection}`
        : undefined;

    const handleKeyDown = (e) => {
        if (e.keyCode === 38 && selection > 0) {
            keyWasPressed.current = 'up';
            setSelection(selection - 1);
            e.preventDefault();
            return;
        }

        if (e.keyCode === 40 && selection < suggestions.length - 1) {
            keyWasPressed.current = 'down';
            setSelection(selection + 1);
            e.preventDefault();
            return;
        }

        if (e.keyCode === 13) {
            if (search) selectSymptom();
            e.preventDefault();
            return;
        }
    }

    const keyPressedOnTag = (e, tag) => {
        if (e.keyCode === 46 || e.keyCode === 8) {
            e.preventDefault();
            removeTag(tag);
            return;
        }
    }

    const handleChange = (e) => {
        setSelection(0);

        if(debouncedQuery)
            setdebouncedQuery('');
        if(search)
            setSearch('');

        if (!e.target.value) {
            setSearch(e.target.value);
            resetSuggestions();
            return;
        }

        if (e.target.value.trim()) {
            setSearch(e.target.value);
        }
    }

    const selectSymptom = (clickIndex) => {
        const index = (clickIndex === undefined)
            ? selection
            : clickIndex;

        if (index < 0 || index > suggestions.length - 1)
            return;

        const symptom = suggestions[index];

        if (tags.some(tag => tag.id === symptom.id))
            return;

        setTags([...tags, symptom]);
        setSuggestions([]);
        setSearch('');
    }

    const removeTag = (tag) => {
        if (tag < 0 || tag > tags.length - 1) return;
        if (disabled) return;

        var newTags = [...tags];
        newTags.splice(tag, 1);
        setTags(newTags);
    }

    const getHighlighted = (text, search) => {
        var texts = [];
        var i = -1;

        if (!search) return text;

        while ((i = text.toLowerCase().indexOf(search.toLowerCase())) !== -1) {
            texts.push(text.substring(0, i));
            texts.push(<span key={text} className='match'>{text.substring(i, i + search.length)}</span>);

            text = text.substring(i + search.length);
        }

        texts.push(text);
        return texts;
    }

    const resetSuggestions = () => {
        setSuggestions([]);
        setSelection(-1);
    }

    const resetSearch = () => {
        setSearch('');
        resetSuggestions();
    }

    const sentenceCase = (text) => {
        if (!text) return text;

        return text.slice(0, 1).toUpperCase() + text.slice(1).toLowerCase();
    }

    const getSuggestions = (searchFor) => {
        setLoadState('LOADING');
        searchFor = searchFor?.replace(/[`~!@#$^&*()<>_+?{}|\\=\[\]\":;]/g, '')?.trim();
        if (!searchFor || searchFor?.length < 1) {
            setLoadState("DONE");
            resetSuggestions();
            return;
        }

        let requestHeaders = {
            "Content-Type": "application/json",
            "Correlation-Id": asyncHBID
        };

        if (env && env.toLowerCase() !== "production") {
            requestHeaders['x-upstream-env'] = "nonprod";
        }
        
        searchPromise = axios({
            method: "post",
            url: symptomTextSearchUrl,
            headers: requestHeaders,
            data: 
                {
                    "query": searchFor,
                    "sex": gender,
                    "age_in_years": age,
                    "max_results": 32,
                    "language":language
                }
          });

        const localPromise = searchPromise;
        // NOTE: This works for single instances only. 
        searchPromise.then(response => {
            if (searchPromise === localPromise) {
                setLoadState("DONE");
                const seenIds = new Set();
                const filteredSuggestions = (response?.data?.data || []).filter(symptom => {
                    if (!symptom.name || tags.some(tag => symptom.id === tag.id) || seenIds.has(symptom.id)) {
                        return false;
                    }

                    seenIds.add(symptom.id);
                    return true;
                });

                setSuggestions(filteredSuggestions);
                 logEventHub(`symptom text search: ${JSON.stringify(filteredSuggestions)}`, 'FE - symptom search text', asyncHBID);
            }
        })
            .catch(function (error) {
                logEventHub('Failed request symptom text search.', 'FE - symptom search text', asyncHBID, 'error');
                if (searchPromise === localPromise) {
                    setLoadState("DONE");
                    setSuggestions([]);
                }
            });
    };
    
    useEffect(() => {
        setLoadState('LOADING');
        const handler = setTimeout(() => {
            setdebouncedQuery(search);
        }, 300);

        return () => {
            clearTimeout(handler);
        };
    }, [search]);

    
    // API call when debouncedQuery changes
    useEffect(() => {
        if (debouncedQuery) {
            getSuggestions(debouncedQuery);
        }
    }, [debouncedQuery]);

    
    useEffect(() => {
        if (selection && keyWasPressed.current) {
            let el = document.querySelector('.suggestions .selected');
            if (el)
                el.scrollIntoView();
            keyWasPressed.current = '';
        }

        if (typeof setBodyPartHover !== 'function')
            setBodyPartHover = () => { };

        if (selection !== 0 && !selection) {
            setBodyPartHover("");
            return;
        }

        if (!suggestions || !suggestions.length) {
            setBodyPartHover("");
            return;
        }

        if (selection < 0 || selection > (suggestions.length - 1)) {
            setBodyPartHover("");
            return;
        }
    })

    useEffect(()=>{
        if(!isMobile){
            var input = document.getElementById('search-for-symptoms')
            input.focus();
        }
    }, [!isMobile]);

    return (
        <div className='symptom-text'>
            {
                isMobile ||
                <>
                    <label htmlFor='search-for-symptoms' >
                        <div className='header'>
                            <h2 className='headerText'>{getMarkDown(headerText)}</h2>
                        </div>
                        <div className='instructions'>{getMarkDown(instructions)}</div>
                    </label>
                </>
            }
            <div>
            <div className='search-input-container'>
            <TextField
                    onFocus={() => { if (showToast instanceof Function) showToast(0) }}
                    size='small'
                    placeholder={placeholder}
                    variant="outlined"
                    id="search-for-symptoms"
                    aria-invalid="false"
                    className={inputDisabled ? 'disabled symptom-search textbox' : 'symptom-search textbox'}
                    onKeyDown={handleKeyDown}
                    onChange={handleChange}
                    value={search}
                    disabled={inputDisabled}
                    autoComplete='off'
                                        inputProps={{
                                                role: 'combobox',
                                                'aria-autocomplete': 'list',
                                                'aria-controls': listboxId,
                                                'aria-expanded': isPopupOpen,
                                                'aria-haspopup': 'listbox',
                                                'aria-activedescendant': activeOptionId,
                                                'aria-label': placeholder || 'Search for symptoms'
                                        }}
                    InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <SearchOutlinedIcon className='search' />
                          </InputAdornment>
                        )
                      }}
                />
                                <div
                                        id={listboxId}
                                        role='listbox'
                                        aria-label='Symptom suggestions'
                                        className='suggestions'
                                        style={search ? { display: 'block' } : { display: 'none' }}
                                >
                        <div>
                            {
                                (loadState === 'LOADING')
                                    ?
                                    <div className='loading'>
                                        {
                                            Array.from({ length: 3 }, (x, i) => {
                                                return (
                                                    <div
                                                        key={'waitbar' + i}
                                                        className='loadAnim'
                                                        style={{ opacity: 1 - (i * .3) }}
                                                    >
                                                        <div className='anim'>&nbsp;</div>
                                                    </div>)
                                            })
                                        }
                                    </div>
                                    :
                                    suggestions.length && loadState === 'DONE'
                                        ?
                                        suggestions.map((symptom, i) => {
                                            return (
                                                <div
                                                    id={`symptom-suggestion-${i}`}
                                                    key={symptom.name + i}
                                                    role='option'
                                                    aria-selected={i === selection}
                                                    className={i === selection ? 'selected suggestion' : 'suggestion'}
                                                    onMouseEnter={() => setSelection(i)}
                                                    onClick={() => selectSymptom(i)}
                                                    title={symptom.name}
                                                >
                                                    {
                                                        getHighlighted(symptom.name, search)
                                                    }
                                                </div>)
                                        })
                                        :
                                        <div className='none'>
                                            {getMarkDown(noResults)}
                                            <span
                                                className='research'
                                                onClick={() => { resetSearch() }} >
                                                {getMarkDown(newSearch)}
                                            </span>
                                        </div>
                            }
                        </div>
                    </div>
                </div> 
            
                <div className='search-container'>     
                <div className='tag-box' style={(tags.length>0 || search.length>0) ? { display: 'block' } : { display: 'none' }}>                 
                        {
                            tags.map((tag, i) => {
                                return (
                                    <button
                                        key={tag.name + inputDisabled}
                                        className='tag'
                                        onKeyDown={(e) => keyPressedOnTag(e, i)}
                                        disabled={disabled}
                                    >
                                        {sentenceCase(tag.name)}
                                        <div
                                            className={disabled ? 'disabled remove' : 'remove'}
                                            onClick={() => removeTag(i)}
                                        >
                                            <CloseIcon />
                                        </div>
                                    </button>)
                            })
                        }
                        {/* {
                            (tags.length >= 6) &&
                            <ButtonTag
                                className='hint tag'
                                type='note'
                                background={HoverColor + '14'}
                            >
                                {onlySix}
                            </ButtonTag>
                        } */}
                </div>
                {
                        showAlert &&
                        <div  className='symptom-info' >
                            <AlertMessageIcon />
                            <span>{hasOnlyInvalidSymptomsSelected.isInvalid ? hasOnlyInvalidSymptomsSelected.message : symptomError?.message}</span>
                        </div>
                }
                <div style={(!search && (tags.length===0 || (!showAlert && tags.length === 1))) ? { display: 'block' } : { display: 'none' }}>
                    <div  className='search-info'>
                        <SearchInfoIcon />
                        <span >{tags.length === 0 ? getMarkDown(searchInformation) : getMarkDown(addMore)}</span>
                    </div>
                </div> 
                
                 {isMobile && (
                    <>
                        {!showToast && setToastMessage && (
                            <div id='toast-bottom-close'>
                                <button
                                    className='close-popup-button'
                                    onClick={() => setToastMessage(null)}
                                >
                                    {closeButton}
                                </button>
                            </div>
                        )}
                    </>
                )}
                    <div
                        className="click-catcher"
                        onClick={() => { resetSearch() }}
                        style={search ? { display: 'block' } : { display: 'none' }}
                    ></div>
                    <div style={(isMobile && toastrClicked) ? { display: 'none' } : { display: 'block' }}>
                       <SymptomCommonReason message={ message} evisits={evisits} setevisits={setevisits} disabled={disabled} setToastMessage={setToastMessage} />
                    </div>                    
                </div>
            </div>
        </div >
    );
};

export default SymptomSearchMessage;